import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { SelectedApexMech } from '@ortho-next/nextray-core';
import { APP_CONFIG, BoneTypeEnum, Fitbone, FitboneSearchFilters } from '../../core';
import { ProductService } from '../../services';
import { BaseComponent } from '../../shared';


/**
* Component of first vertical sidebar to select the template.
*/
@Component({
	selector: 'template-selection',
	templateUrl: './template-selection.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
})
export class TemplateSelectionComponent extends BaseComponent implements OnInit {

	private readonly config = inject(APP_CONFIG);
	private readonly prodSrv = inject(ProductService);

	fitboneList?: Fitbone[];
	insertionApproach: string | null = null;

	readonly LOADER_URL = this.config.cdnUrl + '/style/images/loading.gif';

	ngOnInit(): void {
		this.insertionApproach = this._insertionApproach;
		this.initFitboneList();
	}

	private initFitboneList(): void {
		const filters: FitboneSearchFilters = { bone: this.bone };
		this.prodSrv.getFitboneList(filters).subscribe(list => this.fitboneList = list);
	}

	private get bone(): BoneTypeEnum.Femur | BoneTypeEnum.Tibia {
		return this.selectedApex === SelectedApexMech.tibiaProximal ? BoneTypeEnum.Tibia : BoneTypeEnum.Femur;
	}

	private get _insertionApproach(): string | null {
		switch (this.selectedApex) {
			case SelectedApexMech.femurProximal: return this.labels().INSERTION_APPROACH_ANTEGRADE_FEMUR;
			case SelectedApexMech.femurDistal: return this.labels().INSERTION_APPROACH_RETROGRADE_FEMUR;
			case SelectedApexMech.tibiaProximal: return this.labels().INSERTION_APPROACH_ANTEGRADE_TIBIA;
			default: return null;
		}
	}

	get diameter(): string {
		return this.fitbone ? `${this.fitbone.diameter} mm` : '-';
	}

	get stroke(): string {
		return this.fitbone ? `${this.fitbone.stroke} mm` : '-';
	}

	get maxLength(): string {
		return this.fitbone ? `${this.fitbone.maxLength} mm` : '-';
	}

	get maxPatientWeight(): string {
		return this.fitbone?.maxPatientWeight ? `${this.fitbone.maxPatientWeight} kg` : '-';
	}

	/**
	* Close the fitbone selection workflow.
	*/
	back(): void {
		this.canvasSrv.dispatch('cancelFitbone');
	}

	/**
	* Insert template.
	*/
	insertTemplate(index: number): void {
		const fitbone = this.fitboneList?.[index];
		this.canvasSrv.dispatch('insertFitbone', fitbone);
	}

	/**
	* Confirm the selected template and close the workflow.
	*/
	confirmTemplate(): void {
		this.canvasSrv.dispatch('confirmFitbone');
		this.canvasSrv.saveState();
	}

}
